export const META_ADS_DESIGN_WIDTH = 1080
export const META_ADS_DESIGN_HEIGHT = 1350
